import removeClass from '../../../general/class/removeClass';

import getVariantClasses from './getVariantClasses';

// ----------------------------------------------------------------------------

function clear(element: HTMLElement): void {
    removeClass(element, getVariantClasses());
    element.innerHTML = '';
}

// ----------------------------------------------------------------------------

export default clear;
